import { FormInput, FormSelect } from '@/shared/ui/components'
import { US_STATES } from '@/shared/config/states'
import type { JoinFormValues } from './form-values'

export type VehicleInfoSectionProps = {
  values: JoinFormValues
  errors: Record<string, string>
  isSubmitting: boolean
  onFieldChange: (field: keyof JoinFormValues, value: string) => void
}

export function VehicleInfoSection({
  values,
  errors,
  isSubmitting,
  onFieldChange,
}: VehicleInfoSectionProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormInput
          id="vehicleMake"
          label="Make"
          required
          value={values.vehicleMake ?? ''}
          onChange={(v) => onFieldChange('vehicleMake', v)}
          error={errors.vehicleMake}
          disabled={isSubmitting}
        />
        <FormInput
          id="vehicleModel"
          label="Model"
          required
          value={values.vehicleModel ?? ''}
          onChange={(v) => onFieldChange('vehicleModel', v)}
          error={errors.vehicleModel}
          disabled={isSubmitting}
        />
      </div>

      <FormInput
        id="vehicleColor"
        label="Color"
        required
        value={values.vehicleColor ?? ''}
        onChange={(v) => onFieldChange('vehicleColor', v)}
        error={errors.vehicleColor}
        disabled={isSubmitting}
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormInput
          id="vehicleLicensePlate"
          label="License plate"
          required
          value={values.vehicleLicensePlate ?? ''}
          onChange={(v) => onFieldChange('vehicleLicensePlate', v)}
          error={errors.vehicleLicensePlate}
          disabled={isSubmitting}
        />
        <FormSelect
          id="vehicleState"
          label="Plate state"
          required
          value={values.vehicleState ?? ''}
          onChange={(v) => onFieldChange('vehicleState', v)}
          error={errors.vehicleState}
          disabled={isSubmitting}
          placeholder="Select state"
          options={US_STATES.map((s) => ({ value: s.code, label: s.name }))}
        />
      </div>
    </div>
  )
}
